import { render, staticRenderFns } from "./HomeCarousel.vue?vue&type=template&id=3a9f8eb8&scoped=true"
import script from "./HomeCarousel.vue?vue&type=script&lang=js"
export * from "./HomeCarousel.vue?vue&type=script&lang=js"
import style0 from "./HomeCarousel.vue?vue&type=style&index=0&id=3a9f8eb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9f8eb8",
  null
  
)

export default component.exports